import { reactToCwp } from '../../../../common/react-utils'
import { ConsolidatedHighlights } from './ConsolidatedHighlights'

export default reactToCwp(ConsolidatedHighlights)
